module.exports = __webpack_public_path__ + "img/sumbit.db6d0c5c.png";